// PageDescription: 비대면진료 웹 진료 신청 완료 페이지
import { TelemedicineRequestCompleteView } from '@/views/telemedicine/request-complete';

const TelemedicineRequestCompletePage = () => {
  return <TelemedicineRequestCompleteView />;
};

export default TelemedicineRequestCompletePage;
